import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import Head from 'next/head'
import Image from 'next/image'
const Navbar = dynamic(() => import('../components/Layouts/Navbar', { ssr: false }));
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../components/Layouts/Breadcrumb', { ssr: false }));
import axios from 'axios'

const HeroBanner = dynamic(() => import('../components/Common/HeroBanner', { ssr: false }));
import algoliasearch from 'algoliasearch/lite';
import {
    InstantSearch,
    Pagination,
    SearchBox,
    connectHits,
    Highlight,
    Configure,
    VoiceSearch,
    connectStateResults,
    connectStats,
} from 'react-instantsearch-dom';
import { CalendarIcon } from "@heroicons/react/outline";
import {
    faMagnifyingGlass,
    faChartLine,
    faNewspaper,
    faShareNodes
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BorderBtn from '../components/Common/BorderBtn'

import { faFacebook, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons'
const WhitePaperNewsletter = () => {
    const mainKey = 'UKQLSUI7R1'
    const securityKey = 'ed79e9bfe318ce8368e033ccc51cf3c7'
    const searchClient = algoliasearch(mainKey, securityKey);
    const [isLoading, setIsLoading] = useState(true);

    const ShareSocial = (share_type, hit) => {
        let url = window.location.href;
        if (share_type == 'facebook') {
            url = encodeURI(url);
            let base_url_fb = `https://www.facebook.com/sharer/sharer.php?u=${process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}`
            const newWindow = window.open(base_url_fb, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
        if (share_type == 'linkedin') {
            let base_url_fb = `https://www.linkedin.com/sharing/share-offsite/?url=${process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}`
            const newWindow = window.open(base_url_fb, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
        if (share_type == 'twitter') {
            let base_url_fb = `http://twitter.com/share?url=${process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}`
            const newWindow = window.open(base_url_fb, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1000);
    }, [])

    const [postsPerPage, setPostsPerPage] = useState(13);

    const [query, setQuery] = useState('');

    function limitText(text, limit) {
        return text.length > limit ? text.slice(0, limit) + "..." : text;
    }

    function formatDateFromUnixTimestamp(unixTimestamp) {
        const timestampMilliseconds = unixTimestamp * 1000;
        const date = new Date(timestampMilliseconds);

        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        };

        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
        return formattedDate;
    }


    const firstSection = (hit, index) => {
        return (
            <div key={hit.objectID} className='col-span-12 lg:col-span-12'>
                <div className='bg-white rounded-lg shadow-md dark:bg-gray-600 lg:mb-6'>
                    <div className="grid grid-cols-12 gap-0 lg:gap-4">
                        <div className="relative col-span-12 xl:col-span-6 lg:col-span-6 md:col-span-6">
                            {(hit.image == "") ?
                                <Link href={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}>
                                    <Image priority={true} 
                                        width={2000} 
                                        height={2000} 
                                        src={process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg'}
                                        alt={hit.altText ? hit.altText : 'DelveInsight'}
                                        className="w-full h-full rounded-lg rounded-b-none lg:h-80 lg:rounded-none lg:rounded-l-lg"
                                    />
                                </Link>
                                :

                                <Link href={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}>
                                    <Image priority={true} 
                                        width={2000} 
                                        height={2000} 
                                        src={process.env.IMG_CDN+hit.image}
                                        alt={hit.altText ? hit.altText : 'DelveInsight'}
                                        className="w-full h-full rounded-lg rounded-b-none lg:h-80 lg:rounded-none lg:rounded-l-lg"
                                    />
                                </Link>
                            }
                            <div className='absolute flex w-full cursor-pointer bottom-2 group'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12 p-4 bg-white rounded-full shadow-lg bottom-4">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
                                </svg>
                                <div className="z-40 hidden w-full h-full shadow-none bg-none" id="dropdown-menu">
                                    <ul className='absolute top-0 flex w-full left-12'>
                                        <li key={`${hit.objectID}-fb`} className="flex justify-between px-4 py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('facebook', hit)}>
                                            <FontAwesomeIcon className='text-[#1877F2]' icon={faFacebook} />
                                        </li>
                                        <li key={`${hit.objectID}-tw`} className="flex justify-between px-4 py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('twitter', hit)}>
                                            <FontAwesomeIcon className='text-[#00acee]' icon={faTwitter} />
                                        </li>
                                        <li key={`${hit.objectID}-ln`} className="flex justify-between px-4 py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('linkedin', hit)}>
                                            <FontAwesomeIcon className='text-[#0072b1]' icon={faLinkedin} />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 xl:col-span-6 lg:col-span-6 md:col-span-6">
                            <div className="p-4">
                                <div className="flex justify-between">
                                    <h3 className="dark:text-white font-semibold text-lg mb-4 uppercase text-[#1b5df3]">Infocus</h3>
                                    {/* <p className='flex my-0 mr-1 text-xs'>
                                        <CalendarIcon
                                            className="flex-shrink-0 w-4 h-4 mr-2 text-indigo-600"
                                            aria-hidden="true"
                                        />
                                        {formatDateFromUnixTimestamp(hit.date_timestamp)}
                                    </p> */}
                                </div>                              
                                <Link href={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}>
                                    <h3 className="mb-0 text-lg font-semibold dark:text-white line-clamp-2">{hit.title}</h3>
                                </Link>
                                <p className="mt-0 text-base dark:text-white line-clamp-6">{hit.short_description}</p>

                                <BorderBtn
                                    buttonLink={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}
                                    buttonTitle={'Read Now'}
                                    customClass="bg-[#1b5df3] text-sm font-semibold text-white px-3 py-2 rounded-md"
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    const CustomHits = connectHits(({ hits }) => (
        <div className="grid grid-cols-12 gap-4">
            {hits.map((hit, index) => (
                index === 0 ? 
                firstSection(hit, index) :
                <div key={hit.objectID} className="col-span-12 xl:col-span-3 lg:col-span-4 md:col-span-6">
                    <div className="h-full bg-white rounded-lg shadow-md dark:bg-gray-600">
                        <div className="relative">
                            {(hit.image == "") ?
                                <Link href={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}>
                                    <Image priority={true} 
                                        width={2000} 
                                        height={2000} 
                                        src={process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg'}
                                        alt={hit.altText ? hit.altText : 'DelveInsight'}
                                        className="w-full h-full rounded-lg rounded-b-none"
                                    />
                                </Link>
                                :

                                <Link href={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}>
                                    <Image priority={true} 
                                        width={2000} 
                                        height={2000} 
                                        src={process.env.IMG_CDN+hit.image}
                                        alt={hit.altText ? hit.altText : 'DelveInsight'}
                                        className="w-full h-full rounded-lg rounded-b-none"
                                    />
                                </Link>
                            }
                            <div className='absolute flex w-full cursor-pointer bottom-2 group'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12 p-4 bg-white rounded-full shadow-lg bottom-4">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
                                </svg>
                                <div className="z-40 hidden w-full h-full shadow-none bg-none" id="dropdown-menu">
                                    <ul className='absolute top-0 flex w-full left-12'>
                                        <li key={`${hit.objectID}-fb`} className="flex justify-between px-4 py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('facebook', hit)}>
                                            <FontAwesomeIcon className='text-[#1877F2]' icon={faFacebook} />
                                        </li>
                                        <li key={`${hit.objectID}-tw`} className="flex justify-between px-4 py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('twitter', hit)}>
                                            <FontAwesomeIcon className='text-[#00acee]' icon={faTwitter} />
                                        </li>
                                        <li key={`${hit.objectID}-ln`} className="flex justify-between px-4 py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('linkedin', hit)}>
                                            <FontAwesomeIcon className='text-[#0072b1]' icon={faLinkedin} />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div className="absolute bg-white right-3 px-3 py-2 rounded-full shadow top-[193px]">
                            <FontAwesomeIcon icon={faShareNodes} size="md" className='text-[#1b5df3]' />
                        </div> */}
                        <div className="p-4">
                            {/* <p className='flex items-center my-0 text-sm'>
                                <CalendarIcon
                                    className="flex-shrink-0 w-4 h-4 mr-2 text-indigo-600"
                                    aria-hidden="true"
                                />
                                {formatDateFromUnixTimestamp(hit.date_timestamp)}
                            </p> */}
                            <Link href={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}>
                                <h3 className="mb-2 text-lg font-semibold dark:text-white line-clamp-1">{hit.title}</h3>
                            </Link>
                            <p className="mt-0 text-base dark:text-white line-clamp-4">{hit.short_description}</p>

                            <div className='text-center'>
                                <BorderBtn
                                    buttonLink={process.env.APP_URL+`/whitepaper-newsletter/${hit.slug}`}
                                    buttonTitle={'Download Now'}
                                    customClass="bg-[#1b5df3] text-sm font-semibold text-white px-3 py-2 rounded-md"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    ));


    const ResultsCount = connectStats(({ nbHits }) => (
        <>
            <div className='flex justify-between h-5 mb-5'>
                <div className="flex items-center mt-3">
                    <FontAwesomeIcon icon={faChartLine} size="sm" style={{ color: '#1B5DF3', paddingRight: '10px' }} /> <p className="text-sm font-semibold">{nbHits} results found {query ? <>for `${query}`</> : ""}</p>
                </div>
                <div className="flex items-center mt-2 text-sm font-semibold">
                    <span className="mr-2 ">Posts Per Page:</span>
                    <select
                        className="px-1 py-0 border rounded"
                        value={postsPerPage}
                        onChange={(e) => setPostsPerPage(parseInt(e.target.value))}
                    >
                        <option value={12}>12</option>
                        <option value={24}>24</option>
                        <option value={36}>36</option>
                    </select>
                </div>
            </div>
        </>
    ));


    const Results = connectStateResults(
        ({ searchState, searchResults, children }) =>
            searchResults && searchResults.nbHits !== 0 ? (
                children
            ) : (

                <div className='my-5 text-center'><h6>No results have been found for <b>`{searchState.query}`</b></h6>.</div>
            )
    );

    const GoToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    return (
        <>
           

            <Navbar />
            <HeroBanner
                background={process.env.IMG_CDN + "img/whitepaper-newsletter/png/Newsletter_Whitepaper%20Listing.webp"}
                title={<>Healthcare Whitepaper and Newsletter</>}
                description={<>Discover Thought-Provoking Insights in Our Exclusive Whitepapers and Stay Informed with Our Pharma Newsletter for the Latest Breakthroughs and their Market Impacts. <br /><br/><i>Elevate Your Understanding, Empower Your Decisions.</i></>}
            />
            <Breadcrumb />
            <div className="flex flex-col justify-center w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8">
                <div className='grid grid-cols-12 gap-4'>
                    <InstantSearch searchClient={searchClient} indexName="newsletterswhitepapers" >
                        <Configure hitsPerPage={postsPerPage} />
                        <div className='col-span-12 lg:col-span-12'>
                            <div className="col-span-12 lg:col-span-9">
                                <div className="relative">
                                    <SearchBox translations={{
                                        placeholder: 'Search for Newsletters/Whitepapers'
                                    }} />
                                    <div>
                                        <span className="search-icon-alg"><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                        
                                        <VoiceSearch
                                            searchAsYouSpeak={false}
                                            translations={{
                                                buttonTitle: 'Voice Search',
                                                disabledButtonTitle: 'Voice Search Disabled',
                                            }}
                                        />
                                    </div>
                                    <ResultsCount />
                                    {
                                        isLoading === true ? <><div className="flex items-center justify-center min-h-screen">
                                            <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                        </div>
                                        </> : <div className="mt-6">
                                            <Results>
                                                <CustomHits />
                                            </Results>
                                        </div>
                                    }
                                    <Pagination showLast onClick={GoToTop} />
                                </div>
                            </div>
                        </div>
                    </InstantSearch>
                </div>
            </div>
            <Footer />
        </>
    )
}


WhitePaperNewsletter.getInitialProps = async (NextPageContext) => {
    const slugData = NextPageContext.pathname
    try {
        const response = await axios.get(process.env.API_URL + '/meta' + slugData);
        return {
            title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
            description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        }
    } catch (error) {
        console.error('Error fetching data:', error.message);
        return {
            title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
            description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        };
    }
}

export default WhitePaperNewsletter;
